let Index = {
    init() {
        if ($('#indexFirstChart').length) {
            this.indexFirstChart();
        }
        if ($('#indexSecondChart').length) {
            this.indexSecondChart();
        }
        if ($('#indexThirdChart').length) {
            this.indexThirdChart();
        }
    },

    indexFirstChart() {
        Highcharts.chart('indexFirstChart', {
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            yAxis: {
                title: {
                    text: ''
                },
                max: 100
            },
            xAxis: {
                accessibility: {
                    rangeDescription: 'Range: 2016 to ' + window.current_year
                }
            },

            legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
            },

            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    pointStart: 2016
                }
            },

            series: [{
                name: 'AEO Programmes (Operational)',
                color: '#0381c3',
                data: window.aeo_operational,
                marker: {
                    symbol: 'circle',
                    radius: 6
                }
            }, {
                name: 'AEO Programmes (Under Development)',
                color: '#009d91',
                data: aeo_development,
                marker: {
                    symbol: 'circle',
                    radius: 6
                }
            }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },
            credits: {
                enabled: false
            }
        });

    },

    indexSecondChart() {
        let dataPrev = {
            2016: [
                ['AMS', 0],
                ['MENA', 0],
                ['WCA', 0],
                ['ESA', 0],
                ['A/P', 0],
                ['EU', 0]
            ],
            2017: [
                ['AMS', 16],
                ['MENA', 3],
                ['WCA', 0],
                ['ESA', 3],
                ['A/P', 12],
                ['EU', 35]
            ],
            2018: [
                ['AMS', 16],
                ['MENA', 6],
                ['WCA', 0],
                ['ESA', 4],
                ['A/P', 12],
                ['EU', 36]
            ],
            2019: [
                ['AMS', 17],
                ['MENA', 6],
                ['WCA', 0],
                ['ESA', 3],
                ['A/P', 12],
                ['EU', 38]
            ],
            2020: [
                ['AMS', 18],
                ['MENA', 8],
                ['WCA', 0],
                ['ESA', 5],
                ['A/P', 13],
                ['EU', 39]
            ]
        };

        let data = {
            2016: [
                ['AMS', 16],
                ['MENA', 3],
                ['WCA', 0],
                ['ESA', 3],
                ['A/P', 12],
                ['EU', 35]
            ],
            2017: [
                ['AMS', 16],
                ['MENA', 6],
                ['WCA', 0],
                ['ESA', 4],
                ['A/P', 12],
                ['EU', 36]
            ],
            2018: [
                ['AMS', 17],
                ['MENA', 6],
                ['WCA', 0],
                ['ESA', 3],
                ['A/P', 12],
                ['EU', 38]
            ],
            2019: [
                ['AMS', 18],
                ['MENA', 8],
                ['WCA', 0],
                ['ESA', 5],
                ['A/P', 13],
                ['EU', 39]
            ],
            2020: [
                ['AMS', 19],
                ['MENA', 10],
                ['WCA', 1],
                ['ESA', 8],
                ['A/P', 17],
                ['EU', 42]
            ]
        };

        let countries = [{
            name: 'ESA',
            color: '#009d91'
        }, {
            name: 'WCA',
            color: '#009d91'
        }, {
            name: 'AMS',
            color: '#009d91'
        }, {
            name: 'EUR',
            color: '#009d91'
        }, {
            name: 'MENA',
            color: '#009d91'
        }, {
            name: 'AP',
            color: '#009d91'
        }];


        function getData(data) {
            return data.map(function (country, i) {
                return {
                    name: country[0],
                    y: country[1],
                    color: countries[i].color
                };
            });
        }

        let chart = Highcharts.chart('indexSecondChart', {
            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            plotOptions: {
                series: {
                    grouping: false,
                    borderWidth: 0
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                shared: true,
                headerFormat: '<span style="font-size: 15px">{point.point.name}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
            },
            xAxis: {
                type: 'category',
                max: 5,
                labels: {
                    useHTML: true,
                    animate: true,
                    formatter: function () {
                        var value = this.value,
                            output;

                        countries.forEach(function (country) {
                            if (country.name === value) {
                                output = country.name;
                            }
                        });

                        // return '<span><img src="https://image.flaticon.com/icons/svg/197/' + output + '.svg" style="width: 40px; height: 40px;"/><br></span>';
                        return output;
                    }
                }
            },
            yAxis: [{
                title: {
                    text: ''
                },
                showFirstLabel: false
            }],
            series: [{
                color: '#e0e0e0',
                pointPlacement: -0.2,
                linkedTo: 'main',
                data: window.aeo_region_prev[window.current_year].slice(),
                name: window.current_year - 1
            }, {
                name: window.current_year,
                id: 'main',
                dataSorting: {
                    enabled: true,
                    matchByName: true
                },
                dataLabels: [{
                    enabled: true,
                    inside: true,
                    style: {
                        fontSize: '16px'
                    }
                }],
                data: getData(window.aeo_region[window.current_year]).slice()
            }],
            exporting: {
                allowHTML: true
            },
            credits: {
                enabled: false
            }
        });

        let years = [2016, 2017, 2018, 2019, 2020, 2021, 2022];

        years.forEach(function (year) {
            let btn = document.getElementById(year);

            btn.addEventListener('click', function () {

                $('.btn-group button').removeClass('active');
                $(btn).addClass('active');

                chart.update({
                    title: {
                        // text: 'Summer Olympics ' + year + ' - Top 5 countries by Gold medals'
                        text: ''
                    },
                    subtitle: {
                        // text: 'Comparing to results from Summer Olympics ' + (year - 4) + ' - Source: <a href="https://en.wikipedia.org/wiki/' + (year) + '_Summer_Olympics_medal_table">Wikipedia</a>'
                        text: ''
                    },
                    series: [{
                        name: year - 1,
                        data: window.aeo_region_prev[year].slice()
                    }, {
                        name: year,
                        data: getData(window.aeo_region[year]).slice()
                    }]
                }, true, false, {
                    duration: 800
                });
            });
        });
    },

    indexThirdChart() {
        Highcharts.chart('indexThirdChart', {
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            yAxis: {
                title: {
                    text: ''
                },
                max: 100
            },
            xAxis: {
                accessibility: {
                    rangeDescription: 'Range: 2016 to ' + window.current_year
                }
            },

            legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
            },

            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    pointStart: 2016
                }
            },

            series: [/*{
                name: 'Customs Mutual Assistance Agreement',
                color: '#0381c3',
                data: [10, 23, 33, 54, 100],
                marker: {
                    symbol: 'circle',
                    radius: 6
                }
            }, */{
                name: 'MRAs Concluded',
                color: '#189cd8',
                data: window.mra_operational,
                marker: {
                    symbol: 'circle',
                    radius: 6
                }
            }, {
                name: 'MRAs Under Negotiation',
                color: '#009d91',
                data: window.mra_development,
                marker: {
                    symbol: 'circle',
                    radius: 6
                }
            }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },
            credits: {
                enabled: false
            }
        });
    }
}

$().ready(() => {
    window.Index = Index;
    window.Index.init();
});
